<template>
	<div class="ReTagGroupList">
		<div class="tag-list">
			<el-tag
				v-for="(tag, index) in value"
				:key="tag.value + index"
				size="small"
				:type="tagType"
				:closable="true"
				:close-transition="false"
				@close="handleClose(tag)"
			>{{ tag.label }}</el-tag>
			<button class="btn btn-simple btn-primary no-border my-0" @click="ShowSearch()">
				<i class="tim-icons icon-simple-add mr-2"></i>Добавить
			</button>
		</div>
		<div class="search" v-if="bShowSearch">
			<ReTreeSearchDrop v-if="strType=='departmentWithStaff'"
				class="select-primary"
				:findId="findId"
				:placeholder="placeholder"
				v-model="objSearch"
				strType="staff"
				@change="add"
			/>
		
			<ReInputSearchDrop v-else
				:findId="findId"
				:placeholder="placeholder"
				v-model="objSearch"
				:objApiMethod="objApiMethod"
				:strApiMethodKey="strApiMethodKey"
				:strType="strType"
				@change="add"
			/>
			<button class="btn btn-simple btn-danger no-border my-0" @click="HideSearch()">
				<i class="tim-icons icon-simple-remove"></i>
			</button>
		</div>
	</div>
</template>

<script>
import { Tag } from "element-ui";
import ReTreeSearchDrop from "src/our_components/ReTreeSearchDrop.vue";
import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";

export default {
	name: "ReTagGroupList",
	components: {
		[Tag.name]: Tag,
		ReTreeSearchDrop,
		ReInputSearchDrop
	},
	props: {
		value: Array,
		tagType: {
			type: String,
			default: "primary",
			description: "Tag type (primary|danger etc)"
		},
		findId: {
			type: String,
			default: ""
		},
		placeholder: String,
		objApiMethod: Object,
		strApiMethodKey: String,
		objSaveApiMethod: {
			type: Object,
			default: function(){return {}}
		},
		objDelApiMethod: Object,
		strType: String,
		selectOpts: Array
	},
	data() {
		return {
			ver: 1,
			objSearch: { inputText: "", selectedVal: "" },
			bShowSearch: false,
			selectVal: '',
			BPCL:{},
		};
	},
	computed: {},
	methods: {
		handleClose(tag) {
			this.value.splice(this.value.indexOf(tag), 1);
			this.$emit("change", this.value);
			this.save();
		},
		add(obj) {
			this.value.push({ value: obj.selectedVal, label: obj.inputText });
			this.$emit("change", this.value);
			this.HideSearch();
			this.save();
		},
		ShowSearch() {
			this.bShowSearch = true;
		},
		HideSearch() {
			this.objSearch = { inputText: "", selectedVal: "" };
			this.bShowSearch = false;
		},
		save() {
			if (!this.$GVO.isEmpty(this.objSaveApiMethod)) {
				if (this.objSaveApiMethod.apiMethod != "") {
					this.$GVO
						.ApiCall(
							this.objSaveApiMethod.apiMethod,
							this.objSaveApiMethod.apiParam
						)
						.then(objApi => {
							if (objApi.success === true) {
								this.BPCL = objApi.data;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}
			}
		},
		del(){
			if (!this.$GVO.isEmpty(this.objDelApiMethod)) {
				if (this.objDelApiMethod.apiMethod != "") {
					this.$GVO
						.ApiCall(
							this.objDelApiMethod.apiMethod,
							this.objDelApiMethod.apiParam
						)
						.then(objApi => {
							if (objApi.success === true) {
								this.BPCL = objApi.data;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}
			}
		}
	}
};
</script>
<style scoped>
.ReTagGroupList .tag-list {
	border-radius: 0.4285rem;
	border: 1px solid #2b3553;
	padding: 0 18px;
}
.ReTagGroupList .search .btn-danger {
	position: absolute;
	right: 20px;
	bottom: 10px;
	z-index: 10;
}
.ReTagGroupList span.el-tag {
	margin-top: 5px;
}
.ReTagGroupList .btn-simple {
	padding: 7px 5px;
}
</style>
